<template>
  <div class="bookword-page">
    <!-- 筛选区 -->
    <div class="card filter-card">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="版本">
          <el-select v-model="filters.bookVersion" placeholder="全部" clearable @change="reload">
            <el-option v-for="v in options.bookVersion" :key="v" :label="v" :value="v" />
          </el-select>
        </el-form-item>
        <el-form-item label="阶段">
          <el-select v-model="filters.stage" placeholder="全部" clearable @change="reload">
            <el-option v-for="v in options.stage" :key="v" :label="v" :value="v" />
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="filters.grade" placeholder="全部" clearable @change="reload">
            <el-option v-for="v in options.grade" :key="v" :label="v" :value="v" />
          </el-select>
        </el-form-item>
        <el-form-item label="学期">
          <el-select v-model="filters.term" placeholder="全部" clearable @change="reload">
            <el-option v-for="v in options.term" :key="v" :label="v" :value="v" />
          </el-select>
        </el-form-item>
        <el-form-item label="单元">
          <el-select v-model="filters.unit" placeholder="全部" clearable @change="reload">
            <el-option v-for="v in options.unit" :key="v" :label="v" :value="v" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="keyword"
            placeholder="搜索单词"
            clearable
            style="width: 160px"
            @keyup.enter.native="search"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 列表 -->
    <div class="card list-card">
      <el-table :data="list" v-loading="loading" stripe>
        <el-table-column prop="word" label="单词" width="140" />
        <el-table-column prop="phonetic" label="音标" width="160" />
        <el-table-column prop="meaning" label="释义" min-width="200" show-overflow-tooltip />
        <el-table-column prop="bookVersion" label="版本" width="140" show-overflow-tooltip />
        <el-table-column prop="stage" label="阶段" width="90" />
        <el-table-column prop="grade" label="年级" width="90" />
        <el-table-column prop="term" label="学期" width="90" />
        <el-table-column prop="unit" label="单元" width="120" show-overflow-tooltip />
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="goWord(scope.row.word)">查词</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
          :current-page="pageNum"
          @current-change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'BookWord',
  data() {
    return {
      filters: {
        bookVersion: '',
        stage: '',
        grade: '',
        term: '',
        unit: ''
      },
      keyword: '',
      options: {
        bookVersion: [],
        stage: [],
        grade: [],
        term: [],
        unit: []
      },
      list: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
      loading: false
    }
  },
  mounted() {
    this.loadOptions()
    this.loadList(true)
  },
  methods: {
    async loadOptions() {
      try {
        const res = await request.get('/bookWord/filterOptions')
        if (res.code === 200 && res.data) {
          this.options = {
            bookVersion: res.data.bookVersion || [],
            stage: res.data.stage || [],
            grade: res.data.grade || [],
            term: res.data.term || [],
            unit: res.data.unit || []
          }
        }
      } catch (e) {
        // 拦截器已提示
      }
    },

    async loadList(reset) {
      if (this.loading) return
      const pageNum = reset ? 1 : this.pageNum
      this.loading = true
      try {
        const params = {
          bookVersion: this.filters.bookVersion,
          stage: this.filters.stage,
          grade: this.filters.grade,
          term: this.filters.term,
          unit: this.filters.unit,
          keyword: this.keyword.trim(),
          pageNum,
          pageSize: this.pageSize
        }
        const res = await request.get('/bookWord/list', { params })
        if (res.code === 200 && res.data) {
          this.list = res.data.records || []
          this.total = res.data.total || 0
          this.pageNum = res.data.current || 1
          this.pageSize = res.data.size || this.pageSize
        }
      } catch (e) {
        // 拦截器已提示
      } finally {
        this.loading = false
      }
    },

    reload() {
      this.loadList(true)
    },
    search() {
      this.loadList(true)
    },
    reset() {
      this.filters = { bookVersion: '', stage: '', grade: '', term: '', unit: '' }
      this.keyword = ''
      this.loadList(true)
    },
    onPageChange(page) {
      this.pageNum = page
      this.loadList(false)
    },
    goWord(word) {
      if (!word) return
      this.$store.dispatch('setWord', word)
      this.$router.push('/wordinfo')
    }
  }
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 16px;
}
.filter-form .el-form-item {
  margin-bottom: 4px;
}
.pagination-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
